import { fromJS, List, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
  setInModel,
} from '../../../utils/helpers/model.helper';
import { LocationDistance } from './location-distance.model';

export const LOCATION_SUGGESTION_RESULT_SCHEMA = Object.freeze({
  ID: '',
  DISTANCE: LocationDistance,
  TEXT: '',
});
const RECORD = generateSchema(LOCATION_SUGGESTION_RESULT_SCHEMA);
const KEYS: any = generateKeys(LOCATION_SUGGESTION_RESULT_SCHEMA);

export class LocationSuggestionResult extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    props = props && props.toMap ? props.toMap() : fromJS(props || {});

    super(props);

    const selfModel = setInModel(this, [
      {
        key: KEYS.DISTANCE,
        value: props.get(KEYS.DISTANCE)
          ? new LocationDistance(this.distance)
          : null,
      },
    ]);

    return selfModel as LocationSuggestionResult;
  }

  get id(): string {
    return this.get(KEYS.ID);
  }

  get distance(): List<LocationDistance> {
    return this.get(KEYS.DISTANCE);
  }

  get text(): string {
    return this.get(KEYS.TEXT);
  }
}
